/**
 * @desc 获取角色对应权限信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** dataType */
  dataType?: number;
  /** 角色ID */
  roleId?: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryPermissionResponse>> {
  return defHttp.get({
    url: '/wap/rolePermission/permissions',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryPermissionResponse>> {
  return defHttp.get({
    url: '/mock/wap/rolePermission/permissions',

    params,
  });
}
